import axios from 'axios';

import setAuthToken from '../cores/setAuthToken';
import { SET_CURRENT_USER, GET_USERS, SHOW_ADVERTISEMENT, GET_LOGIN_ERROR, GET_POPUP_DATA, SET_BANKLIST, GET_LOGIN_CAPTCHA, SET_AGENCYLIST, SET_MARKETNAMELIST, SET_EVENTPARTNAMELIST, SET_ALLUSERDATA, SET_SHOWLEFT } from './types';

import store from '../store';
import { api_url } from '../cores/keys';
import { autoLogout, convertObj, isEmpty, isMobilePage, messageMusic, showMessage, toastr } from '../cores';
import { GetMessageData } from './moreAction';
import { SetCurrentPage, SetMessagePage, SetPageLoading } from './pageAction';
import { initSocket, processData, repair_site, socket } from '../cores/socket';
import { ClearBetStore } from './betAction';

// Update user
export const changePassword = (data) => dispatch => {
   axios.post(api_url + '/api/Users/passwordChange', data)
      .then(res => {
         showMessage(res.data.message);
      })
      .catch(err => {
         console.error('err: ', err);
         dispatch(SetPageLoading(false));
         console.error(err);

         if (err.response && err.response.status === 401)
            return dispatch(logoutUser());

         toastr.warning('잠시후 다시 시도해주세요.');
      });
}

// Update user
export const updateUser = (data) => dispatch => {
   return new Promise(resolve => {
      axios.post(api_url + '/api/Users/updateUserInfo', data)
         .then(res => {
            showMessage(res.data.message);
            resolve(res.data);
         })
         .catch(err => {
            console.error('err: ', err);
            dispatch(SetPageLoading(false));
            console.error(err);

            if (err.response && err.response.status === 401)
               return dispatch(logoutUser());

            toastr.warning('잠시후 다시 시도해주세요.');
         });
   })
}

export const ShowAdvertisement = (show) => dispatch => {
   dispatch({
      type: SHOW_ADVERTISEMENT,
      payload: show
   })
}

export const SetLoginError = (data) => dispatch => {
   dispatch({
      type: GET_LOGIN_ERROR,
      payload: data
   })
}

export const SetPopupData = (data) => dispatch => {
   dispatch({
      type: GET_POPUP_DATA,
      payload: data
   })
}

// Login User
let isLoadingNow = false;
export const loginUser = userData => dispatch => {
   // //console.log(userData)
   // dispatch(SetLoginError({}));
   if (isLoadingNow) {
      return new Promise(resolve => { });
   }
   userData = {
      ...userData,
      platform: isMobilePage() ? "MOBILE" : "PC",
      ipADD: localStorage.getItem('client-ip')
   }
   return new Promise(resolve => {
      dispatch(SetPageLoading(true));
      isLoadingNow = true;
      axios.post(api_url + '/api/Users/login', userData)
         .then(res => {
            setTimeout(() => { isLoadingNow = false }, 500);
            dispatch(SetPageLoading(false));
            if (res.data.status === 2) {
               toastr.warning("점검중입니다.");
               // //console.log('convertObj(res.data.message.warning): ', convertObj(res.data.message.warning));
               return processData("repair_site", convertObj(res.data.message.warning));
            }
            if (res.data.status === 1) {
               showMessage(res.data.message);
               dispatch(GetCaptcha());
               return dispatch(SetLoginError('아이디 혹은 비번이 맞지 않습니다.'));
            }
            // window.ws.close();
            // Save to localStorage
            const { token, adminToken, user, popups } = res.data;
            // Set Token to ls
            localStorage.setItem('jwtToken', token);
            // localStorage.setItem('adminToken', adminToken);
            // Set Token to Auth header
            setAuthToken(token);
            dispatch(getUserInfo());
            // //console.log("로그인 팝업내용:", popups)
            // dispatch(SetPopupData(popups));
            dispatch(setAllData(res.data))
            dispatch(setCurrentUser(user));
            // dispatch(ShowAdvertisement(true));
            // axios.post(api_url + '/api/Users/honorlinklogin', user);

            toastr.success(`${user.name} ${isEmpty(window.lang["환영합니다"]) ? "환영합니다" : window.lang["환영합니다"]}`);
            // initSocket(token);
            if (window.ws.readyState === 1) {
               window.ws.send(JSON.stringify({ MessageType: 'PublicLogin', token }));
            }

            autoLogout();
            resolve();
         })
         .catch(err => {
            console.error('err: ', err);
            setTimeout(() => { isLoadingNow = false }, 500);
            dispatch(SetPageLoading(false));
            console.error(err);

            toastr.warning('잠시후 다시 시도해주세요.');
         });
   });
}

//Captcha
export const GetCaptcha = () => dispatch => {
   return new Promise(resolve => {
      axios.post(api_url + '/api/Users/captcha')
         .then(res => {
            resolve(res.data);
            dispatch(SetCaptcha(res.data));
         })
         .catch(err => {
            console.error('err: ', err);
            dispatch(SetPageLoading(false));
            console.error(err);

            if (err.response && err.response.status === 401)
               return dispatch(logoutUser());

            toastr.warning('잠시후 다시 시도해주세요.');
         });
   })
}

// Set logged in user
export const setCurrentUser = (decoded) => dispatch => {
   // //console.log(decoded)
   dispatch({
      type: SET_CURRENT_USER,
      payload: decoded
   })
}

export const setAllData = (decoded) => dispatch => {
   // //console.log(decoded)
   dispatch({
      type: SET_ALLUSERDATA,
      payload: decoded
   })
}

export const SetCaptcha = (data) => dispatch => {
   dispatch({
      type: GET_LOGIN_CAPTCHA,
      payload: data
   })
}

export const SetShowLeft = data => dispatch => {
   dispatch({
      type: SET_SHOWLEFT,
      payload: data
   })
}

export const getUserInfo = () => dispatch => {
   axios.post(api_url + '/api/Users/getMyData', {})
      .then(res => {
         // //console.log("------------------------------gameCnt------------------------ :", res.data.gameCnt)

         if (res.data.status) {
            showMessage(res.data.message);
            return dispatch(logoutUser());
         }
         dispatch(setCurrentUser(res.data.user));
         dispatch(setAllData(res.data))
         // //console.log('res.data.user: ', res.data.user);
         dispatch(GetMessageData({ page: 1, perPage: store.getState().page.perPage, unSetPage: true, noneLoading: true }));
         if (!isEmpty(res.data.repair_site)) {
            processData(convertObj(res.data.repair_site).MessageType, convertObj(res.data.repair_site));
         }
         if (!isEmpty(res.data.bet_setting)) {
            processData(convertObj(res.data.bet_setting).MessageType, convertObj(res.data.bet_setting));
         }
         if (!isEmpty(res.data.gameCnt)) {
            processData(convertObj(res.data.gameCnt).MessageType, convertObj(res.data.gameCnt));
            //console.log('convertObj(res.data.gameCnt).MessageType, convertObj(res.data.gameCnt): ', convertObj(res.data.gameCnt).MessageType, convertObj(res.data.gameCnt));
         }
         if (!isEmpty(res.data.bigleagueCnt)) {
            processData(convertObj(res.data.bigleagueCnt).MessageType, convertObj(res.data.bigleagueCnt));
            //console.log('convertObj(res.data.gameCnt).MessageType, convertObj(res.data.gameCnt): ', convertObj(res.data.gameCnt).MessageType, convertObj(res.data.gameCnt));
         }
         if (!isEmpty(res.data.market_setting)) {
            processData(convertObj(res.data.market_setting).MessageType, convertObj(res.data.market_setting));
         }
         if (!isEmpty(res.data.game_setting)) {
            processData(convertObj(res.data.game_setting).MessageType, convertObj(res.data.game_setting));
         }
         if (!isEmpty(res.data.baseline_setting)) {
            processData(convertObj(res.data.baseline_setting).MessageType, convertObj(res.data.baseline_setting));
         }
         if (!isEmpty(res.data.provider_setting)) {
            processData(convertObj(res.data.provider_setting).MessageType, convertObj(res.data.provider_setting));
         }
         if (!isEmpty(res.data.reconnect_setting)) {
            processData(convertObj(res.data.reconnect_setting).MessageType, convertObj(res.data.reconnect_setting));
         }
         if (!isEmpty(res.data.delay_setting)) {
            processData(convertObj(res.data.delay_setting).MessageType, convertObj(res.data.delay_setting));
         }
         // socket.emit("me", res.data.user);
         // setInterval(()=>{
         //    dispatch(SetCurrentPage())
         // },2000)
      }).catch(err => {
         console.error('err: ', err);

         dispatch(SetPageLoading(false));
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         // else
         //    toastr.warning('잠시후 다시 시도해주세요.');

         //console.log("user info error : ", err);

         dispatch(setCurrentUser({}));
         dispatch(setAllData({}))
      });
}

// Logout user
export const logoutUser = (message = false) => dispatch => {
   messageMusic.stop();
   axios.post(api_url + "/api/Users/logout", {
      ipADD: localStorage.getItem('client-ip'),
      adminToken: localStorage.getItem('adminToken'),
   })
      .then(res => {
         //console.log(res.data);
      })
      .catch(err => {
         console.error('err: ', err);
         //console.log(err);
      })
   localStorage.removeItem('jwtToken');
   localStorage.removeItem('adminToken');
   localStorage.removeItem('bettingItem');
   setAuthToken(false);
   // window.ws.close();
   // initSocket();
   // dispatch(SetPageLoading(true));
   if (window.windowHandle) {
      //  toastr.warning("배팅이 취소되었습니다.")
      window.windowHandle.close();
   }
   if (store.getState().user.isAuthenticated && !message) {
      toastr.warning(isEmpty(window.lang["로그아웃되었습니다."]) ? "로그아웃되었습니다." : window.lang["로그아웃되었습니다."]);
   }

   // dispatch(setCurrentUser({}));
   dispatch({
      type: SET_CURRENT_USER,
      payload: {}
   })
   dispatch(ClearBetStore());
}


export const getPublicPopup = () => dispatch => {
   axios.post(api_url + "/api/Popup/get", {})
      .then(res => {
         // //console.log(res.data);
         dispatch(SetPopupData(res.data.popups));
         dispatch(ShowAdvertisement(true));
      })
      .catch(err => {
         console.error('err: ', err);
         //console.log(err);
      })
   // SetPopupData(popups)
   // window.ws.close();
   // initSocket();
}

export const getPrivatePopup = () => dispatch => {
   axios.post(api_url + "/api/Popup/getpopup", {})
      .then(res => {
         //console.log(res.data);
         dispatch(SetPopupData(res.data.popups));
         dispatch(ShowAdvertisement(true));
      })
      .catch(err => {
         console.error('err: ', err);
         //console.log(err);
      })
   // SetPopupData(popups)
   // window.ws.close();
   // initSocket();
}

export const getBankName = () => {
   axios.post(api_url + "/api/Users/getBankData")
      .then(res => {
         if (res.data.status) {
            store.dispatch(setBankNames(res.data.bankList));
         }
      })
      .catch(err => {
         console.error('err: ', err);
         //console.log('err: ', err);
         if (!store.getState().user.isAuthenticated) {
            toastr.warning("잠시후 다시 시도해주세요.");
         }
      })
}

export const setBankNames = (data) => {
   return ({
      type: SET_BANKLIST,
      payload: data
   })
}

export const getAgencyName = () => {
   axios.post(api_url + "/api/Users/getAgencyData")
      .then(res => {
         if (res.data.status) {
            store.dispatch(setAgencyNames(res.data.agencyList));
         }
      })
      .catch(err => {
         console.error('err: ', err);
         //console.log('err: ', err);
         if (!store.getState().user.isAuthenticated) {
            toastr.warning("잠시후 다시 시도해주세요.");
         }
      })
}

export const getMarketName = () => {
   axios.post(api_url + "/api/Users/getMarketData")
      .then(res => {
         if (res.data.success) {
            store.dispatch(setMarketName(res.data.data))
         }
      })
      .catch(err => {
         console.error('err:', err);
         if (!store.getState().user.isAuthenticated) {
            toastr.warning("잠시후 다시 시도해주세요.")
         }
      })
}

export const getEventParttName = () => {
   axios.post(api_url + "/api/Users/getEventPartData")
      .then(res => {
         if (res.data.success) {
            store.dispatch(setEventpartName(res.data.data))
         }
      })
      .catch(err => {
         console.error('err:', err);
         if (!store.getState().user.isAuthenticated) {
            toastr.warning("잠시후 다시 시도해주세요.")
         }
      })
}

export const setAgencyNames = (data) => {
   return ({
      type: SET_AGENCYLIST,
      payload: data
   })
}

export const setMarketName = (data) => {
   return ({
      type: SET_MARKETNAMELIST,
      payload: data
   })
}

export const setEventpartName = (data) => {
   return ({
      type: SET_EVENTPARTNAMELIST,
      payload: data
   })
}


// WEBPACK FOOTER //
// ./src/common/actions/userActions.js